<template>
    <fragment>
        <div class="wraper-video">
            <div v-if="poster.src" class="content-image">
                <img width="100%" tabindex="0" :src="poster.src" :alt="poster.title"/>
                <div v-show="isOffline" class="content-image__offline"
                    :class="{'content-image__offline--overlay':poster.src}">
                    <span class="icon icon-offline"></span>
                    <span class="content-image__offline-text">You have to be online to view this content</span>
                </div>
                <div :class="{ 'd-block': show, 'd-none': !show, 'w-100': true, 'h-100': true }">
                    <video v-if="isJACareerEntrepreApp" controls ref="jamediaplayer" class="w-100 h-100">
                        <source v-for="(video, index) in sources"
                                :key="`video-source-${index}`"
                                :src="video.src"
                                :type="video.type"
                                :media="video.media"
                        >
                    </video>
                    <video v-else ref="azuremediaplayer" tabindex="0" autoplay controls
                        class="azuremediaplayer amp-default-skin amp-big-play-centered">
                    </video>
                </div>
            </div>
            <b-button v-if="!(isOffline && poster.src) && !show" @click="playVideo" :disabled="isOffline"
                    :class="['play-video', classNamePlay]" variant="outline-primary">
                <span class="icon"
                    :class="{'icon-play':isOnline && !isJACareerEntrepreApp,
                        'icon-play-dark':isOnline && isJACareerEntrepreApp,
                        'icon-offline':isOffline}"></span>
            </b-button>
        </div>
    </fragment>
</template>

<script>
import {Analytics} from '../Utils'

export default {
    name: "JAVideo",
    props: {
        sources: {
            type: Array,
            required: true
        },
        title: {
            type: String
        },
        classNamePlay: {
            type: String
        },
        poster: {
            type: Object,
            default: () => ({
                src: null,
                title: null,
            }),
        }
    },
    data() {
        return {
            player: null,
            show: false
        }
    },
    methods: {
        loadAmpScript: function () {
            return new Promise((resolve) => {
                if (document.getElementById('ja_amp_script')) {
                    return resolve()
                }
                let scriptTag = document.createElement('script');
                scriptTag.id = 'ja_amp_script';
                scriptTag.src = 'https://amp.azure.net/libs/amp/2.3.4/azuremediaplayer.min.js'
                document.head.appendChild(scriptTag);
                scriptTag.onload = () => resolve()
            })
        },
        createPlayer: function () {
            const options = {
                controls: true,
                width: "100%",
                height: "auto"
            };

            this.player = window.amp(this.$refs.azuremediaplayer, options, function () {
                //'this' refers to the player instance in the ready function
            });

            this.player.addEventListener('playing', this._ampEventHandler);
        },
        setVideo: function () {
            this.player.src(this.sources)
        },
        _ampEventHandler: function (e) {
            this.show = true
        },
        playVideo: function () {
            if (this.isJACareerEntrepreApp){
                this._ampEventHandler();
                this.$refs.jamediaplayer.play();
            } else {
                if (this.player !== null) {
                    this.setVideo()
                    Analytics.sendVideoEvent(this.title, this.$route.params.index, this.$route.path, this.$route.name)

                    setTimeout(() => {
                        this.player.play()
                    }, 500)
                }
            }
        }
    },
    created() {
        if (!this.isJACareerEntrepreApp) {
            this.loadAmpScript().then(() => {
                this.createPlayer()
            })
        }
    },
    destroyed() {
        if (!this.isJACareerEntrepreApp) {
            this.player && this.player.dispose()
        }
    }
}
</script>

<style lang="stylus" scoped>
@import "~@/core/Styles/variables.styl"
@import "https://amp.azure.net/libs/amp/2.3.4/skins/amp-default/azuremediaplayer.min.css";

.wraper-video
    position relative

.content-image
    position relative

    &__offline
        display flex
        justify-content center
        align-items center
        flex-direction column
        background-color rgba(color-7, 0.85)
        min-height 200px

        .icon
            width 57px
            height 48px

        &-text
            font font-poppins-semibold
            font-size 14px
            width 65%
            text-align center
            padding-top 10px
            color color-4

        &--overlay
            position absolute
            height 100%
            width 100%
            top 0
            left 0

.d-block
    position absolute
    top 0px
    width 100%

</style>
